const MOBILE_WIDTH = 767;
const TABLET_WIDTH = 1023;

const metric = {
    state: {
        modalBodyComponent: '',
        isModalVisible: false,
        notificationInfo: {
            isVisible: false,
            status: '',
            text: '',
            autoClose: false,
            closeIcon: '/sprite.svg#close',
            action: () => {},
            actionText: ''
        },
        isMenuPanelVisible: false,
        isMobMenuVisible: false,
        windowWidth: 0,
        isSidebarVisible: true,
        currentSidebarTab: 'PreviewViewer',
        modalSessionStatus: '',
        isMainImgLandscape: false
    },
    mutations: {
        CHANGE_MODAL_TITLE(state, obj) {
            state.modalInfo = obj;
        },
        SET_MODAL_IS_VISIBLE(state, payload) {
            state.isModalVisible = payload;
        },
        SET_MODAL_SESSION_STATUS(state, status) {
            state.modalSessionStatus = status;
        },
        SET_MOB_MENU_IS_VISIBLE(state, payload) {
            state.isMobMenuVisible = payload;
        },
        SET_SIDEBAR_IS_VISIBLE(state, payload) {
            state.isSidebarVisible = payload;
        },
        SET_CURRENT_SIDEBAR_TAB(state, payload) {
            state.currentSidebarTab = payload;
        },
        SET_MODAL_BODY_COMPONENT(state, payload) {
            state.modalBodyComponent = payload;
        },
        SET_WINDOW_WIDTH(state, payload) {
            state.windowWidth = payload;
        },
        SET_NOTIFICATION_INFO(state, payload) {
            state.notificationInfo = { ...state.notificationInfo, ...payload };
        },
        SET_MENU_PANEL_VISIBILITY(state, payload) {
            state.isMenuPanelVisible = payload;
        },
        SET_MAIN_IMG_IS_LANDSCAPE(state, payload) {
            state.isMainImgLandscape = payload;
        }
    },
    actions: {
        showModal({ commit }, payload) {
            const component = payload instanceof Object ? payload.component : payload;
            const { session } = payload;
            commit('SET_MODAL_IS_VISIBLE', true);
            commit('SET_MODAL_BODY_COMPONENT', component);
            if (session) {
                commit('SET_MODAL_SESSION_STATUS', session);
            }
        },
        closeModal({ commit }) {
            commit('SET_MODAL_IS_VISIBLE', false);
            commit('SET_MODAL_BODY_COMPONENT', '');
        },
        showNotification({ commit }, payload) {
            if (payload instanceof Error) {
                commit('SET_NOTIFICATION_INFO', {
                    text: `Ошибка сети - ${payload.message}`,
                    status: 'error',
                    isVisible: true
                });
            } else {
                commit('SET_NOTIFICATION_INFO', {
                    autoClose: true,
                    isVisible: true,
                    ...payload
                });
            }
        }
    },
    getters: {
        getModalTitle: (state) => {
            switch (state.modalBodyComponent) {
            case 'ModalDownload': return 'Загрузка документа';
            case 'ModalInfo': return 'Справка по работе с приложением';
            case 'ModalError': return 'Загрузка документа';
            case 'RslCardItem': return 'Описание';
            case 'ModalWelcome': return 'Добро пожаловать в защищенный просмотр';
            case 'ModalSession': return 'Сессия просмотра';
            case 'ModalTestRoom': return 'Зал для тестирования';
            case 'ModalRemoveMark': return 'Удалить метку';
            default: return false;
            }
        },
        isMobMenuVisible: state => state.isMobMenuVisible,
        isModalVisible: state => state.isModalVisible,
        getModalBodyComponent: state => state.modalBodyComponent,
        isMobile: state => state.windowWidth <= MOBILE_WIDTH,
        isTablet: state => state.windowWidth > MOBILE_WIDTH && state.windowWidth <= TABLET_WIDTH,
        isDesktop: state => state.windowWidth > TABLET_WIDTH,
        getNotificationInfo: state => state.notificationInfo,
        isMenuPanelVisible: state => state.isMenuPanelVisible,
        getCurrentSidebarTab: state => state.currentSidebarTab,
        isSidebarVisible: state => state.isSidebarVisible,
        isSessionStatus: state => state.modalSessionStatus,
        isMainImgLandscape: state => state.isMainImgLandscape
    }
};

export default metric;
